import { render, staticRenderFns } from "./Tipomanufatto.vue?vue&type=template&id=369b6c69&scoped=true&"
import script from "./Tipomanufatto.vue?vue&type=script&lang=js&"
export * from "./Tipomanufatto.vue?vue&type=script&lang=js&"
import style0 from "./Tipomanufatto.vue?vue&type=style&index=0&id=369b6c69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369b6c69",
  null
  
)

export default component.exports